// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Numero d'objet
export default class NumeroObjet  {
  // Identifiant unique
  public id: number;
  // Numéro
  public code: string;
  // libellé
  public label: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.label = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: NumeroObjet): NumeroObjet {
    const newNumeroObjet: NumeroObjet = new NumeroObjet();
    newNumeroObjet.id = obj.id;
    newNumeroObjet.code = obj.code;
    newNumeroObjet.label = obj.label;
    newNumeroObjet.createId = obj.createId;
    newNumeroObjet.failed = obj.failed;
    newNumeroObjet.canUpdate = obj.canUpdate;
    newNumeroObjet.canDelete = obj.canDelete;
    newNumeroObjet.display = obj.display;
    newNumeroObjet.clientId = obj.clientId;
    newNumeroObjet.notifDefType = obj.notifDefType;
    return newNumeroObjet;
  }

  public toJsonNumeroObjet (): string {
    const json = {
      code: this.code,
      label: this.label,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromNumeroObjet (obj: NumeroObjet): void {
    this.id = obj.id;
    this.code = obj.code;
    this.label = obj.label;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareNumeroObjet (value: NumeroObjet): boolean {
    return (this.toJsonNumeroObjet() == value.toJsonNumeroObjet());
  }

  public cloneNumeroObjet (): NumeroObjet {
    return NumeroObjet.fromJson(this);
  }

  public createForStoreNumeroObjet (): Promise<NumeroObjet> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/numeroobjets/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromNumeroObjet(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreNumeroObjet (): Promise<NumeroObjet> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/numeroobjets/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromNumeroObjet(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreNumeroObjet (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/numeroobjets/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/numeroobjets/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/NumeroObjets/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = NumeroObjet.fromJson(listData.reccords[0] as NumeroObjet);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<NumeroObjet> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/NumeroObjets/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = NumeroObjet.fromJson(listData.reccords[0] as NumeroObjet);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(numeroObjets: NumeroObjet[]) {
  }
}
